import { MOCK_NOTIFICATIONS } from '../../../../mocks/notifications.mock'

export const loadNotifications = async () => {
  await new Promise((resolve) => setTimeout(resolve, 300))
  return MOCK_NOTIFICATIONS
}
